.uiWindow[window-name=subscription-info-sticky][type=popover] {
  min-width: 315px;
  transform: none !important;
  top: 11vh !important;
  left: calc(50vw - 315px - 235px) !important;
  --sticky-bg: #fef49c;
}

.uiWindow[window-name=subscription-info-sticky][type=popover] {
  --windowRadiusSmall: 12px;
  --windowRadiusSmall-inner: calc(var(--windowRadiusSmall) - 1px);
  width: 293px;
  transform: none;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.15);
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .sp {
  max-width: 2em;
  height: 2em;
  width: 2em;
  float: left;
  margin-right: 0.5em;
  transform: translate(0, 0.05em);
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .message-support {
  cursor: pointer;
  text-decoration: underline;
}
.uiWindow[window-name=subscription-info-sticky][type=popover][position=center] {
  bottom: 3rem;
  left: auto;
  top: auto;
  right: 10rem;
  position: fixed;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .close.close-uiWindow {
  position: absolute;
  right: 10px;
  top: 10px;
  display: none;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content {
  font-family: var(--fontFamily-default);
  font-size: var(--fontSize-default);
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner {
  background: var(--sticky-bg);
  padding: 15px;
  color: rgba(var(--baseColor-default-reverse-rgb), 0.85);
  font-size: var(--fontSize-default);
  font-weight: 400;
  font-family: "CargoDiatypeVariable";
  letter-spacing: 0;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner .linked {
  text-decoration: underline;
  color: inherit;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner .linked:active {
  opacity: 0.7;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner b {
  font-weight: 800;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner .title {
  display: flex;
  font-size: 26px;
  font-weight: 500;
  line-height: 1.1;
  font-style: italic;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner .title.large {
  font-weight: 700;
  color: #D16044;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner .title.large .emojicheck {
  font-style: normal;
  margin-right: 0.2em;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner .legend {
  display: block;
  line-height: 1.3;
  margin-left: 20px;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner .legend .legend-item {
  display: flex;
  align-items: center;
  margin-top: 0.1em;
}
.uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content .uiWindow-inner .legend .legend-item .icon {
  position: relative;
  display: inline-flex;
  margin-right: 0.1em;
}

.dark .uiWindow[window-name=subscription-info-sticky][type=popover] {
  --sticky-bg: var(--ui-hint-background);
}
.dark .uiWindow[window-name=subscription-info-sticky][type=popover] .uiWindow-content {
  background: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */